export default class Breadcrumb {
  title: string;
  link?: string;

  constructor(args: { title: string; link?: string }) {
    this.title = args.title;
    this.link = args.link;
  }
}
